export class EntityResult {
    constructor(data, meta) {
        this.data = data;
        this.meta = meta;
    }
    [Symbol.iterator]() {
        return [this.data][Symbol.iterator]();
    }
}
export class CollectionResult {
    constructor(data, meta) {
        this.data = data;
        this.meta = meta;
    }
    [Symbol.iterator]() {
        return this.data[Symbol.iterator]();
    }
}
//# sourceMappingURL=Result.js.map